import { FacebookShare } from './Facebook';
import { LinkShare } from './Link';
import Menu from '@material-ui/core/Menu';
import PropTypes from 'prop-types';
import React from 'react';
import { Share as ShareButton } from '../buttons';
import { TwitterShare } from './Twitter';
import { connect } from 'react-redux';
import { selectors } from 'app-webtech-core';
import { userCountryCodeSelector } from '../../../../application/selectors/isUserAccountEnabled';
import { withNamespaces } from 'react-i18next';
import { withPlayer } from '../../PlayerContext';

class ShareComponent extends React.Component {
  static propTypes = {
    channel: PropTypes.shape({
      name: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      number: PropTypes.number.isRequired,
    }),
    isTrivia: PropTypes.bool,
    nowPlaying: PropTypes.shape({
      title: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    }).isRequired,
    player: PropTypes.shape({
      containerRef: PropTypes.object.isRequired,
    }).isRequired,
    countryCode: PropTypes.string.isRequired,
    t: PropTypes.func.isRequired,
    marketingRegion: PropTypes.string.isRequired,
  };

  static defaultProps = {
    channel: null,
    isTrivia: false,
  };

  state = {
    anchorEl: null,
  };

  close = () => {
    this.setState({ anchorEl: null });
  };

  open = (e) => {
    this.setState({ anchorEl: e.currentTarget });
  };

  render() {
    const { anchorEl } = this.state;
    const { channel, isTrivia, nowPlaying, player, t, marketingRegion } = this.props;

    let url;
    if (typeof window !== 'undefined') {
      const { href } = window.location;
      const searchStart = href.indexOf('?');
      url = searchStart > -1 ? href.substring(0, searchStart) : href;
    }

    let text;
    if (isTrivia) {
      text = 'Join fans live for Winner and a Movie. A live interactive trivia show.';
    } else if (channel) {
      text = t('watch_channel_with_me_live', {
        defaultValue: 'Watch {content_title} on {channel_name} (CH {channel_number}) with me live!',
        content_title: nowPlaying.title,
        channel_name: channel.name,
        channel_number: channel.number,
      });
    } else {
      text = t('watch_on_demand_for_free', {
        defaultValue: 'Watch {content_title} on demand for free!',
        content_title: nowPlaying.name,
      });
    }

    let hashtag;
    let account;
    if (marketingRegion === 'latam') {
      hashtag = 'PlutoTVLATAM';
      account = 'PlutoTV_LATAM';
    } else if (marketingRegion === 'es') {
      hashtag = 'PlutoTVES';
      account = 'PlutoTVES';
    } else if (marketingRegion === 'uk') {
      hashtag = 'PlutoTVUK';
      account = 'PlutoTVUK';
      // GSA countries: de = Germany, ch = Switzerland, at = Austria
    } else if (marketingRegion === 'gsa') {
      hashtag = 'PlutoTVDACH';
      account = 'PlutoTVDACH';
    } else if (marketingRegion === 'fr'){
      hashtag = 'plutotvfr';
      account = 'plutotvfr';
      //French hashtag is lowercase, this is not a typo
    } else {
      hashtag = 'PlutoTV';
      account = 'PlutoTV';
    }

    return (
      <React.Fragment>
        <ShareButton
          aria-owns={anchorEl ? 'share-menu' : null}
          aria-haspopup="true"
          onClick={this.open}
        />
        {anchorEl && window.outerHeight > 500 && (
          <Menu
            anchorEl={anchorEl}
            id="share-menu"
            onClose={this.close}
            open={Boolean(anchorEl)}
            container={player.containerRef && player.containerRef.current}
          >
            <FacebookShare onClick={this.close} text={text} url={url} hashtag={hashtag} />
            <TwitterShare
              isTrivia={isTrivia}
              onClick={this.close}
              text={text}
              url={url}
              hashtag={hashtag}
              account={account}
            />
            <LinkShare onClick={this.close} url={url} />
          </Menu>
        )}
        {anchorEl && window.outerHeight < 500 && (
          <Menu
            anchorEl={anchorEl}
            style={{ top: -50 }}
            id="share-menu"
            onClose={this.close}
            open={Boolean(anchorEl)}
            container={player.containerRef && player.containerRef.current}
          >
            <FacebookShare onClick={this.close} text={text} url={url} hashtag={hashtag} />
            <TwitterShare
              isTrivia={isTrivia}
              onClick={this.close}
              text={text}
              url={url}
              hashtag={hashtag}
              account={account}
            />
            <LinkShare onClick={this.close} url={url} />
          </Menu>
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  countryCode: userCountryCodeSelector(state),
  marketingRegion: selectors.playbackSession.properties(state).marketingRegion,
});

export const Share = connect(mapStateToProps)(withNamespaces()(withPlayer(ShareComponent)));
